<div class="row align-items-center">
  <div class="col">

    <!-- Title -->
    <h4 class="mb-1">
      {{ getName() }}
    </h4>

    <p [class.text-bg-primary]="questionnaire.status == 'CREATED' || questionnaire.status == 'IN_PROGRESS'"
      [class.text-bg-success]="questionnaire.status == 'FINALIZED'"
    class="badge mt-3">{{ getStatusText() }}</p>
  </div>
  @if (showShowAccessQuestionnaireButton) {
    <div class="col-auto">
      <a [routerLink]="'/questionnaires/' + questionnaire.keyname + '/' + questionnaire.id"
      class="btn btn-sm btn-primary">Accéder au questionnaire</a>
    </div>
  }
</div> <!-- / .row -->